export default __webpack_public_path__ + "static/media/about_img.80e3cf47.png";